export const OUVIDORIA_URL = 'https://www.sebraepr.com.br/artigos/ouvidoria';
